import { useCompoundBody } from "@react-three/cannon"
import { useGLTF } from "@react-three/drei"
import { useRef, useState } from "react"
import { Group, Material, Mesh, MeshStandardMaterial } from "three"
import { ObjectProps, useDragConstraint } from "../utils"
import { asset } from "../../consts"
import type { GLTF } from "three-stdlib/loaders/GLTFLoader";

interface GuitarGLTF extends GLTF {
  materials: {
    default: Material
    Liquid: Material
  }
  nodes: {
    Acoustic_Guitar_Cube034: Group,
    Acoustic_Guitar_Cube034_1: Mesh,
    Acoustic_Guitar_Cube034_1_1: Mesh,
    Acoustic_Guitar_Cube034_1_2: Mesh,
    Acoustic_Guitar_Cube034_1_3: Mesh,
  }
}

export default ({position, rotation}: ObjectProps) => {
  const { nodes } = useGLTF(asset('/models/Guitar.glb')) as any as GuitarGLTF
  
  const [ref] = useCompoundBody(() => ({
    mass: 50,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [0.3, 1.25, 1], mass: 5, position: [-0.2, 0.9, 0], rotation: [0, 0, Math.PI / 9], type: 'Box' },
      { args: [0.3, 4.25, 0.7], mass: 5, position: [0, -1.75, 0], type: 'Box' },
      { args: [1.5, 1.5, 0.8], mass: 15, position: [-0.375, -3.5, 0], rotation: [0, 0, Math.PI / 2], type: 'Cylinder' },
      { args: [0.8, 3.2, 3.5], mass: 25, position: [-0.375, -6, 0], rotation: [0, 0, 0], type: 'Box',  }, // hack: ギタースタンドで安定しないため
    ], 
    type: 'Dynamic',
  }), useRef<Group>(null));

  const guitarBodyMaterial = new MeshStandardMaterial({color: '#eaca80', roughness: 0.8, metalness: 0.1 });
  const guitarNeckMaterial = new MeshStandardMaterial({color: '#7c5547', roughness: 0.8, metalness: 0.1 });
  const guitarStringsMaterial = new MeshStandardMaterial({color: '#4e6a7c', roughness: 0.2, metalness: 0.8 });
  const bind = useDragConstraint(ref);

  const handlePointerEnter = () => { document.body.style.cursor = 'grab';    };
  const handlePointerLeave = () => { document.body.style.cursor = 'default'; };

  return (
    <group 
      ref={ref} 
      {...bind} 
      dispose={null}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
    >
      <group scale={[0.4, 0.4, 0.4]} position={[-0.5, -5.5, 0]}>
        <mesh
          receiveShadow
          castShadow
          material={guitarBodyMaterial}
          geometry={nodes['Acoustic_Guitar_Cube034_1'].geometry}
        />
        <mesh
          receiveShadow
          castShadow
          material={guitarBodyMaterial}
          geometry={nodes['Acoustic_Guitar_Cube034_1_1'].geometry}
        />
        <mesh
          receiveShadow
          castShadow
          material={guitarNeckMaterial}
          geometry={nodes['Acoustic_Guitar_Cube034_1_2'].geometry}
        />
        <mesh
          receiveShadow
          castShadow
          material={guitarStringsMaterial}
          geometry={nodes['Acoustic_Guitar_Cube034_1_3'].geometry}
        />
      </group>
    </group>
  );
};

